var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      staticClass: "w100",
      style: { height: "100%;" },
      attrs: { value: true, "escape-close": "" },
    },
    [
      _c(
        "w-container",
        { style: { padding: "0 0 0 0" } },
        [
          _c(
            "w-row",
            {
              style: { height: "100%", flexWrap: "nowrap" },
              attrs: { "no-margin": "" },
            },
            [
              _c(
                "div",
                {
                  class: { narrow: true },
                  style: {
                    padding: "0 0 0 0",
                    width: (_vm.width > 1755 ? 115 : 115) + "px",
                  },
                },
                [
                  _c("app-groups", {
                    attrs: { config: _vm.config },
                    on: {
                      "update-group": function ($event) {
                        return _vm.updateGroup($event)
                      },
                      "save-config": function ($event) {
                        return _vm.saveConfig($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { style: { padding: "0 0 0 0", width: "972px" } },
                [
                  _vm.state
                    ? _c("app-products", {
                        attrs: {
                          state: _vm.state,
                          config: _vm.config,
                          "active-group-id": _vm.activeGroupID,
                        },
                        on: {
                          "save-config": function ($event) {
                            return _vm.saveConfig($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { style: { padding: "0 0 0 0", flexGrow: 1 } },
                [
                  _c("app-total", {
                    attrs: { state: _vm.state },
                    on: {
                      saved: function ($event) {
                        return _vm.onSaleSaved($event)
                      },
                      init: _vm.initSale,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }